import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { Itinerary } from '../../entities/master-data/itinerary-entity';


export class ItineraryRequest extends BaseRequest{
  itinerary : Itinerary;
  constructor(userInfo : UserInfo){
    super(userInfo);
    this.itinerary = new Itinerary();
  }
}